import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div(({ theme }) => ({
    margin: theme.spacing.medium,
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    boxShadow: "0px 8px 16px rgba(27, 30, 36, 0.1)",
    borderRadius: theme.cornerRadius.medium,
    padding: theme.spacing.medium,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const NoteText = styled(Text)(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing.medium,
    ":last-child": {
        marginBottom: 0,
    },
}));

export const ListItems = styled.div(({ theme }) => ({
    margin: `${theme.spacing.xSmall} 0 0`,
}));

export const ItemIcon = styled.div(({ theme }) => ({
    borderRadius: theme.cornerRadius.rounded,
    border: `3px solid ${theme.colors[theme.colorMode].border_Primary}`,
    marginRight: theme.spacing.xSmall,
    marginTop: theme.spacing.xxSmall,
}));
